import { Node_Type } from './../ricos-types';

import type { BordersType } from './types';

export const DEFAULT_PALETTE_BG = [
  '#FF0000',
  '#FFFFFF',
  '#303030',
  '#3A54B4',
  '#BFAD80',
  '#DDDDDD',
];

export const SOURCE = {
  KEYBOARD_SHORTCUT: 'keyboard shortcut',
  PLUS_BUTTON: 'plus button',
  CONTEXT_MENU: 'context menu',
};

export const LOCATION = {
  RIGHT: 'right',
  LEFT: 'left',
  ABOVE: 'above',
  BELOW: 'below',
};

export const CATEGORY = {
  COLUMN: 'column',
  ROW: 'row',
  ENTIRE_TABLE: 'entire table',
  CELL_BORDER: 'cell border',
  ROW_HEADER: 'row header',
  COLUMN_HEADER: 'column header',
  CELL_FORMATTING: 'cell formatting',
  RANGE: 'range',
  ROW_RANGE: 'row range',
  COLUMN_RANGE: 'column range',
};

export const CELL_MANUAL_MIN_WIDTH = 65;
export const CELL_AUTO_MIN_WIDTH = 120;
export const ROW_DEFAULT_HEIGHT = 47;

export const TABLE_BUTTONS = {
  FORMATTING: `${Node_Type.TABLE}.formatting`,
  VERTICAL_ALIGNMENT: `${Node_Type.TABLE}.verticalAlignment`,
  BACKGROUND_COLOR: `${Node_Type.TABLE}.backgroundColor`,
  ROW_HEADER: `${Node_Type.TABLE}.rowHeader`,
  COLUMN_HEADER: `${Node_Type.TABLE}.columnHeader`,
  BORDER: `${Node_Type.TABLE}.border`,
  CONTEXT: `${Node_Type.TABLE}.contextMenu`,
};

export const TABLE_BUTTONS_MODALS_ID = {
  BORDER: `${Node_Type.TABLE}.border`,
  VERTICAL_ALIGNMENT: `${Node_Type.TABLE}.verticalAlignment`,
  CONTEXT: `${Node_Type.TABLE}.contextMenu`,
};

export const TABLE_COMMANDS_KEYS = {
  CLEAR: 'clearCell',
  DELETE_TABLE: 'deleteTable',
  DELETE_ROW: 'deleteRow',
  DELETE_COLUMN: 'deleteColumn',
  INSERT_ABOVE: 'addRowBefore',
  INSERT_BELOW: 'addRowAfter',
  INSERT_LEFT: 'addColumnBefore',
  INSERT_RIGHT: 'addColumnAfter',
  MERGE_CELLS: 'mergeCells',
  SPLIT_CELL: 'splitCell',
  DISTRIBUTE_ROWS: 'distributeRows',
  DISTRIBUTE_COLUMNS: 'distributeColumns',
  SELECT_ROWS: 'selectRow',
  SELECT_COLUMNS: 'selectColumn',
} as const;

export const TABLE_COLOR_PICKER = 'table-colorPicker';

export const BORDER_TYPES: {
  borders: BordersType;
  outsideBorders: BordersType;
} = { borders: 'borders', outsideBorders: 'outsideBorders' };
